import { v4 } from "uuid";
import { getDescriptionInfo, getDeviceName } from "utils/ItemDescription";
import { FLOWS } from "app/ducks/GlobalSlice";

export const getPlansFirstPackageId = (
  device,
  planFirstPackages,
  flow,
  plansFirstCategories
) => {
  let packageId = device?.packageId;
  if (!packageId && planFirstPackages?.length > 0) {
    let isPlansFirstCategory =
      plansFirstCategories?.includes(device?.deviceName) ||
      device?.deviceName === "smartphone";
    let isPlansFirstDevice = flow === "plans-first" && isPlansFirstCategory;
    packageId = isPlansFirstDevice ? planFirstPackages?.shift() : "";
    packageId = packageId?.toString().includes("LINE") ? packageId : "";
  }
  return packageId;
};

export const getMultiSimPayload = ({
  zipCode,
  pdpBillingAddress,
  devices,
  isEmptyByodFromDQFlow,
  isEditPackageFlow,
  editPackagePackageId,
  isAddMoreByodPackage,
  planFirstPackages,
  flow,
  plansFirstCategories,
  planId,
  isAgentLink,
}) => {
  const lines = [];
  let deviceType = "SMARTPHONE";

  for (const device of devices) {
    const packageId = getPlansFirstPackageId(
      device,
      planFirstPackages,
      flow,
      plansFirstCategories
    );
    deviceType =
      device?.deviceInfo?.category == "Smartphones" ||
      device?.deviceInfo?.category == "Connected Smartwatches" ||
      device?.deviceInfo?.category == "Phones" ||
      device?.deviceInfo?.category == "BroadbandAccess Devices"
        ? "SMARTPHONE"
        : device?.deviceInfo?.category == "Connected Laptops"
        ? "LAPTOP"
        : device?.deviceInfo?.category == "Tablets"
        ? "TABLET"
        : device?.deviceInfo?.category == "Connected Devices"
        ? "DESKPHONE"
        : "SMARTPHONE";
    let packageType = deviceType === "DESKPHONE" ? "ONETALK" : "REGULAR";
    if (isAgentLink) {
      let payload = {
        packageId: packageId || device?.packageId || "",
        packageType: packageType,
        operation: "UPDATE",
        device: {
          deviceSku: device?.deviceInfo?.deviceSkuId,
          deviceType: deviceType,
          deviceCategory:
            device?.deviceInfo?.category || deviceType === "TABLET"
              ? "Tablets"
              : "Connected Laptops",
          quantity: "1",
          priceType: "MONTH_TO_MONTH",
          simType:
            device?.selectedOpt === "esim" || device?.selectedOpt === "old"
              ? "E"
              : "P",
          byod: true,
          portIn: device?.isVZNumber?.toLowerCase() === "yes",
          byodInfo:
            device?.selectedOpt == "new"
              ? {
                  imei: device?.imei,
                  deviceSku: device?.deviceInfo?.deviceSkuId,
                  newSim: true,
                  imageSet: device?.deviceInfo?.imageSet,
                  simSku: device?.deviceInfo?.simSku,
                }
              : {
                  imei: device?.imei,
                  newSim: false,
                  deviceSku: device?.deviceInfo?.deviceSkuId,
                  simNumber: device?.iccid,
                  imageSet: device?.deviceInfo?.imageSet,
                  simSku: device?.deviceInfo?.simSku,
                },
        },
      };
      if (device?.selectedFeature) {
        payload.features = [
          {
            operation: "ADD",
            ...device.selectedFeature,
          },
        ];
      }
      lines.push(payload);
    }
    if (
      device?.displayType === "ByMakeAndMod" &&
      device?.selectedCarrier !== "Other" &&
      !device?.packageId &&
      !device?.isEditable
    ) {
      let payload = {
        packageId: packageId || device?.packageId || "",
        packageType: packageType,
        operation:
          packageId || device.fromLearn
            ? "UPDATE"
            : isEmptyByodFromDQFlow
            ? "UPDATE"
            : "ADD",
        device: {
          deviceSku: device?.selectedDevice?.sku,
          deviceType: deviceType,
          deviceCategory: device?.deviceInfo?.category || "Smartphones",
          quantity: "1",
          priceType: "MONTH_TO_MONTH",
          simType: device?.onlyEsim ? "E" : "P",
          byod: true,
          portIn: device?.isVZNumber?.toLowerCase() === "yes",
          byodInfo: {
            carrier: device?.selectedCarrier,
            newSim: true,
            skipImei: true,
            imageSet: device?.selectedDevice?.imageName,
          },
        },
      };
      if (device?.selectedFeature) {
        payload.features = [
          {
            operation: "ADD",
            ...device.selectedFeature,
          },
        ];
      }
      payload =
        packageId || device.fromLearn
          ? payload
          : device?.deviceInfo?.category
              ?.toLowerCase()
              .includes("smartphone") ||
            device?.deviceName?.toLowerCase()?.includes("smartphone")
          ? { ...payload, plan: { planId } }
          : payload;
      lines.push(payload);
    }
    if (
      device?.displayType === "ByMakeAndMod" &&
      device?.selectedCarrier === "Other" &&
      !device?.packageId &&
      !device?.isEditable
    ) {
      let payload = {
        packageId: packageId || device?.packageId || "",
        packageType: packageType,
        operation: packageId || device.fromLearn ? "UPDATE" : "ADD",
        device: {
          deviceSku: device?.deviceInfo?.deviceSkuId,
          deviceType: deviceType,
          deviceCategory: device?.deviceInfo?.category || "Smartphones",
          quantity: "1",
          priceType: "MONTH_TO_MONTH",
          simType: device?.selectedOpt === "esim" ? "E" : "P",
          byod: true,
          portIn: device?.isVZNumber?.toLowerCase() === "yes",
          byodInfo:
            device?.selectedOpt == "new"
              ? {
                  imei: device?.imei,
                  newSim: true,
                  imageSet: device?.deviceInfo?.imageSet,
                }
              : {
                  imei: device?.imei,
                  newSim: false,
                  simNumber: device?.iccid,
                  imageSet: device?.deviceInfo?.imageSet,
                },
        },
      };
      if (device?.selectedFeature) {
        payload.features = [
          {
            operation: "ADD",
            ...device.selectedFeature,
          },
        ];
      }
      payload =
        packageId || device.fromLearn
          ? payload
          : device?.deviceInfo?.category
              ?.toLowerCase()
              .includes("smartphones") ||
            device?.deviceName.toLowerCase().includes("smartphone")
          ? { ...payload, plan: { planId } }
          : payload;
      lines.push(payload);
    }
    if (
      device?.displayType === "ByImei" &&
      !device?.packageId &&
      !device?.isEditable
    ) {
      let payload = {
        packageId: packageId || device?.packageId || "",
        packageType: packageType,
        operation: packageId || device.fromLearn ? "UPDATE" : "ADD",
        device: {
          deviceSku: device?.deviceInfo?.deviceSkuId,
          deviceType: deviceType,
          deviceCategory: device?.deviceInfo?.category || "Smartphones",
          quantity: "1",
          priceType: "MONTH_TO_MONTH",
          simType:
            device?.selectedOpt === "esim" || device?.selectedOpt === "old"
              ? "E"
              : "P",
          byod: true,
          portIn: device?.isVZNumber?.toLowerCase() === "yes",
          byodInfo:
            device?.selectedOpt == "new"
              ? {
                  imei: device?.imei,
                  newSim: true,
                  imageSet: device?.deviceInfo?.imageSet,
                }
              : {
                  imei: device?.imei,
                  newSim: false,
                  simNumber: device?.iccid,
                  imageSet: device?.deviceInfo?.imageSet,
                },
        },
      };
      if (device?.selectedFeature) {
        payload.features = [
          {
            operation: "ADD",
            ...device.selectedFeature,
          },
        ];
      }
      payload =
        packageId || device.fromLearn
          ? payload
          : device?.deviceInfo?.category
              ?.toLowerCase()
              .includes("smartphone") ||
            device?.deviceName?.toLowerCase()?.includes("smartphone")
          ? { ...payload, plan: { planId } }
          : payload;
      lines.push(payload);
    }
    if (
      (isEditPackageFlow &&
        (editPackagePackageId || device?.isDQ || isAddMoreByodPackage) &&
        device?.packageId &&
        device?.updated) ||
      ((device?.displayType === "ByMakeAndMod" ||
        device?.displayType === "ByImei") &&
        device?.packageId &&
        device?.updated &&
        !isAgentLink)
    ) {
      if (
        device?.displayType === "ByMakeAndMod" &&
        device?.selectedCarrier !== "Other"
      ) {
        let payload = {
          packageId: packageId || device?.packageId || "",
          packageType: packageType,
          operation:
            packageId ||
            isEmptyByodFromDQFlow ||
            isEditPackageFlow ||
            device.fromLearn
              ? "UPDATE"
              : "ADD",
          device: {
            deviceSku: device?.selectedDevice?.sku,
            deviceType: deviceType,
            deviceCategory: device?.deviceInfo?.category || "Smartphones",
            quantity: "1",
            priceType: "MONTH_TO_MONTH",
            simType: device?.onlyEsim ? "E" : "P",
            byod: true,
            portIn: device?.isVZNumber?.toLowerCase() === "yes",
            byodInfo: {
              carrier: device?.selectedCarrier,
              newSim: true,
              skipImei: true,
              imageSet: device?.selectedDevice?.imageName,
            },
          },
        };
        if (device?.selectedFeature) {
          payload.features = [
            {
              operation: "ADD",
              ...device.selectedFeature,
            },
          ];
        }
        payload =
          packageId || device.fromLearn
            ? payload
            : device?.deviceInfo?.category
                ?.toLowerCase()
                .includes("smartphones") ||
              device?.deviceName.toLowerCase().includes("smartphone")
            ? { ...payload, plan: { planId } }
            : payload;
        lines.push(payload);
      }
      if (
        device?.displayType === "ByMakeAndMod" &&
        device?.selectedCarrier === "Other"
      ) {
        let payload = {
          packageId: packageId || device?.packageId || "",
          packageType: packageType,
          operation:
            packageId || isEditPackageFlow || device.fromLearn
              ? "UPDATE"
              : "ADD",
          device: {
            deviceSku: device?.deviceInfo?.deviceSkuId,
            deviceType: deviceType,
            deviceCategory: device?.deviceInfo?.category || "Smartphones",
            quantity: "1",
            priceType: "MONTH_TO_MONTH",
            simType: device?.selectedOpt === "esim" ? "E" : "P",
            byod: true,
            portIn: device?.isVZNumber?.toLowerCase() === "yes",
            byodInfo:
              device.selectedOpt == "new"
                ? {
                    imei: device?.imei,
                    newSim: true,
                    imageSet: device?.deviceInfo?.imageSet,
                  }
                : {
                    imei: device?.imei,
                    newSim: false,
                    simNumber: device?.iccid,
                    imageSet: device?.deviceInfo?.imageSet,
                  },
          },
        };
        if (device?.selectedFeature) {
          payload.features = [
            {
              operation: "ADD",
              ...device.selectedFeature,
            },
          ];
        }
        payload =
          packageId || device.fromLearn
            ? payload
            : device?.deviceInfo?.category
                ?.toLowerCase()
                .includes("smartphones") ||
              device?.deviceName.toLowerCase().includes("smartphone")
            ? { ...payload, plan: { planId } }
            : payload;
        lines.push(payload);
      }
      if (device?.displayType === "ByImei") {
        let payload = {
          packageId: packageId || device?.packageId || "",
          packageType: packageType,
          operation:
            packageId || isEditPackageFlow || device.fromLearn
              ? "UPDATE"
              : "ADD",
          device: {
            deviceSku: device?.deviceInfo?.deviceSkuId,
            deviceType: deviceType,
            deviceCategory: device?.deviceInfo?.category || "Smartphones",
            quantity: "1",
            priceType: "MONTH_TO_MONTH",
            simType:
              device?.selectedOpt === "esim" || device?.selectedOpt === "old"
                ? "E"
                : "P",
            byod: true,
            portIn: device?.isVZNumber?.toLowerCase() === "yes",
            byodInfo:
              device?.selectedOpt == "new"
                ? {
                    imei: device?.imei,
                    newSim: true,
                    imageSet: device?.deviceInfo?.imageSet,
                  }
                : {
                    imei: device?.imei,
                    newSim: false,
                    simNumber: device?.iccid,
                    imageSet: device?.deviceInfo?.imageSet,
                  },
          },
        };
        if (device?.selectedFeature) {
          payload.features = [
            {
              operation: "ADD",
              ...device.selectedFeature,
            },
          ];
        }
        payload =
          packageId || device.fromLearn
            ? payload
            : device?.deviceInfo?.category
                ?.toLowerCase()
                .includes("smartphones") ||
              device?.deviceName.toLowerCase().includes("smartphone")
            ? { ...payload, plan: { planId } }
            : payload;
        lines.push(payload);
      }
    }
  }

  const defaultPayload = {
    cartMeta: { zipCode, pdpBillingAddress, shoppingPath: "prospect" },
    approach:
      flow === "plans-first" || flow === FLOWS.PLANFIRST ? "plans-first" : "",
    lines,
  };
  return defaultPayload;
};

export const getInitialDeviceState = () => ({
  imei: "",
  deviceName: "smartphone",
  deviceInfo: null,
  selectedOpt: null,
  id: v4(),
  iccid: "",
  isVZNumber: "",
  isOldSimVerified: false,
  completed: false,
  selectedCarrier: null,
  selectedDevice: null,
  displayType: "",
  hasDeviceID: "true",
  isEditable: false,
  deviceSku: null,
  updated: false,
  fromLearn: false,
  isByor:false
});

export const getByodDeviceList = ({
  cartPackages = [],
  isAgentLink = false,
}) => {
  const byodDevice = Object.keys(cartPackages).map((key) => {
    const pack = cartPackages?.[key];
    const description = pack?.description || "";
    const extractedImageSet = description.split(":_:").pop(); // Extract the last part of the description
    if (
      pack?.byod &&
      !pack?.byor &&
      ((!isAgentLink && (pack?.fromLearn || pack?.deviceSku)) ||  
      (isAgentLink &&
          (key.includes("BYODTABLET") || key.includes("BYODLAPTOP") || key.includes("BYODSMARTPHONE"))))
    ) {
      const deviceName = getDeviceName(pack);
      const { brand, name } = getDescriptionInfo(pack);
      const isSmartphone =
        pack && pack.deviceCategory?.toLowerCase()?.includes("Smartphone");
      const msg = key.includes("BYODTABLET")
        ? "Tablet"
        : isSmartphone
        ? "Smartphone"
        : "Laptop";
      const selectedByodDevice = {
        imageName: pack?.imageSet,
        modelName: pack?.productName,
        sku: pack?.deviceSku,
        carrier: pack?.carrierData,
      };
      const deviceInformation = {
        brand: pack?.productName,
        imageSet: pack?.imageSet || pack?.image_name || pack?.imageURL || pack?.description?.split(":_:").pop() || "default-image",
        imei: pack?.imei || "",
      };
      let deviceInfo = isAgentLink ? { ...getInitialDeviceState() } : {};
      deviceInfo = {
        ...deviceInfo,
        deviceSku: pack?.deviceSku,
        message: pack?.deviceCategory ?? msg,
        make: brand,
        modal: name,
        packageId: key,
        technologyType: pack.technologyType,
        deviceName: deviceName,
        selectedCarrier: pack?.carrierData || "",
        selectedDevice: selectedByodDevice,
        imei: pack?.imei || "",
        iccid: pack?.iccid || "",
        category: pack?.deviceCategory,
        imageSet: pack?.imageSet,
        esimCapable: pack?.esimCapable,
        selectedOpt: pack?.newSim ? "new" : "old",
        displayType: pack?.carrier ? "ByMakeAndMod" : "ByImei",
        newSim: pack?.newSim,
        isEditable: false,
        isVZNumber: pack?.portIn ? "Yes" : "No",
        portIn: pack?.portIn,
        productName: pack?.productName,
        psimCapable: pack?.psimCapable,
        simSku: pack?.simSku,
        deviceInfo: deviceInformation,
        completed: true,
      };
      return deviceInfo;
    }
  });
  return byodDevice;
};
